var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-buttons"},[_c('p',{staticClass:"control has-addons"},_vm._l((_vm.buttons),function(button,index){return _c('toggle-button',{key:index,attrs:{"active":_vm.value == button.value},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_vm._v(_vm._s(button.label))])}),1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7e91b34","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/toggle-buttons/toggleButtons.vue
// module id = 497
// module chunks = 2